<template>

    <div class="w-full">
        <h4 class="mb-3">Clients</h4>

        <vs-button color="success" icon-pack="feather" icon="icon-plus-circle" class="mb-3" @click="addClientPrompt = true">Add</vs-button>

        <vx-card id="clientsDiv"  class="vs-con-loading__container">

            <vs-table ref="table" @selected="openClient" :data="tableData" class="mt-3" pagination search :maxItems="itemsPerPage">
                <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-start">

                    <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4" v-if="tableData.length > 0">
                        <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ tableItems - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : tableItems }} of {{ tableItems }}</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                        </div>

                        <vs-dropdown-menu>

                            <vs-dropdown-item @click="itemsPerPage=10">
                                <span>10</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=20">
                                <span>20</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=50">
                                <span>50</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=100">
                                <span>100</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=250">
                                <span>250</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=500">
                                <span>500</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=1000">
                                <span>1000</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>

                    <vs-button color="primary" icon-pack="feather" icon="icon-file-text" class="mb-3" @click="exportClientsToExcel">Export</vs-button>
                </div>

                <template slot="thead">
                    <vs-th sort-key="erp_reference_id">ERP Reference</vs-th>
                    <vs-th sort-key="name">Name</vs-th>
                    <vs-th sort-key="username">Username</vs-th>
                    <vs-th sort-key="email">Email</vs-th>
                    <vs-th sort-key="mac_address">MAC Address</vs-th>
                    <vs-th sort-key="reseller_username">Reseller</vs-th>
                    <vs-th sort-key="subscriber">Subscriber</vs-th>
                    <vs-th sort-key="credits">Credits</vs-th>
                    <vs-th sort-key="connections">Connections</vs-th>
                    <vs-th sort-key="stb_access_pin_formatted">STB Pin</vs-th>
                    <vs-th sort-key="stb_registered">STB Registered</vs-th>
                    <vs-th sort-key="enabled">Status</vs-th>
                    <vs-th sort-key="subscriptions_active">Subscriptions active</vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

                        <vs-td :data="data[index].erp_reference_id">
                            {{ data[index].erp_reference_id }}
                        </vs-td>

                        <vs-td :data="data[index].name">
                            {{ data[index].name }}
                        </vs-td>

                        <vs-td :data="data[index].username">
                            {{ data[index].username }}
                        </vs-td>

                        <vs-td :data="data[index].email">
                            {{ data[index].email }}
                        </vs-td>

                        <vs-td :data="data[index].mac_address">
                            {{ data[index].mac_address }}
                        </vs-td>

                        <vs-td :data="data[index].reseller_username">
                            {{ data[index].reseller_username }}
                        </vs-td>

                        <vs-td :data="data[index].subscriber">
                            {{ data[index].subscriber }}
                        </vs-td>

                        <vs-td :data="data[index].credits">
                            {{ data[index].credits }}
                        </vs-td>

                        <vs-td :data="data[index].connections">
                            {{ data[index].connections }}
                        </vs-td>

                        <vs-td :data="data[index].stb_access_pin_formatted">
                            {{ data[index].stb_access_pin_formatted }}
                        </vs-td>

                        <vs-td :data="data[index].stb_registered">
                            <vs-chip color="success" v-if="data[index].stb_registered">Yes</vs-chip>
                            <vs-chip color="danger" v-else>No</vs-chip>
                        </vs-td>

                        <vs-td :data="data[index].enabled">
                            <vs-chip color="success" v-if="data[index].enabled">Enabled</vs-chip>
                            <vs-chip color="danger" v-else>Disabled</vs-chip>
                        </vs-td>

                        <vs-td :data="data[index].subscriptions_active">
                            <vs-chip color="success" v-if="data[index].subscriptions_active > 0">{{data[index].subscriptions_active}}</vs-chip>
                            <vs-chip color="danger" v-else>0</vs-chip>
                        </vs-td>

                    </vs-tr>
                </template>
            </vs-table>
        </vx-card>

        <vs-popup title="Add client" :active.sync="addClientPrompt">
            <div id="addClientDiv" class="vs-con-loading__container" >
                <p class="mt-6">ERP Reference Id</p>
                <vs-input v-model="addObject['erp_reference_id']" class="w-full"></vs-input>
                <p class="mt-6">Subscriber</p>
                <vs-select autocomplete class="w-full" v-model="addObject['subscriber_id']">
                    <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in subscribers" />
                </vs-select>
                <p class="mt-6">Name</p>
                <vs-input v-model="addObject['name']" class="w-full"></vs-input>
                <p class="mt-6">Email</p>
                <vs-input v-model="addObject['email']" class="w-full"></vs-input>
                <p class="mt-6">Username</p>
                <vs-input v-model="addObject['username']" class="w-full"></vs-input>
                <p class="mt-6">MAC Address</p>
                <vs-input v-model="addObject['mac_address']" class="w-full"></vs-input>
                <p class="mt-6">Connections</p>
                <vs-input v-model="addObject['connections']" class="w-full"></vs-input>
                <vs-divider/>
                <vs-button color="success" class="mt-6; mr-1" @click="addClient">Add</vs-button>
            </div>
        </vs-popup>

    </div>

</template>
<script>

    export default {

        data() {
            return {

                itemsPerPage: 20,
                isMounted: false,

                clients: [],
                subscribers: [],

                addClientPrompt: false,

                addObject: {

                }

            }
        },
        methods: {

            loadData() {
                this.$vs.loading({
                    container: '#clientsDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/client/')
                loadPromise.then(function(response) {
                    thisIns.clients = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                const subscribersPromise = this.$http.get('/api/management/v1/subscriber/')
                subscribersPromise.then(function(response) {
                    thisIns.subscribers = [{id: 0, name: "No subscriber"}].concat(response.data)
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                Promise.all([loadPromise, subscribersPromise]).finally(function() {
                    thisIns.$vs.loading.close('#clientsDiv > .con-vs-loading')
                })
            },
            addClient() {
                this.$vs.loading({
                    container: '#addClientDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this

                const addPromise = this.$http.post('/api/management/v1/client/', {
                    erp_reference_id: Number(this.addObject.erp_reference_id),
                    subscriber_id: Number(this.addObject.subscriber_id),
                    name: this.addObject.name,
                    email: this.addObject.email,
                    username: this.addObject.username,
                    mac_address: this.addObject.mac_address,
                    connections: Number(this.addObject.connections)
                })

                addPromise.then(function(response) {
                    thisIns.addClientPrompt = false
                    thisIns.$printSuccess('Client added')
                    thisIns.$nextTick(() => {
                        thisIns.$router.push('/client/' + response.data.id)
                    })
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#addClientDiv > .con-vs-loading')
                })
            },
            openClient(tr) {
                this.$router.push('/client/' + tr.id)
            },
            exportClientsToExcel() {
                if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
                    || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) {
                    window.location.href = 'api/management/v1/exports/clients/all';
                }else{
                    window.open('api/management/v1/exports/clients/all');
                }
            }
        },
        computed: {
            currentPage() {
                if (this.isMounted) {
                    return this.$refs.table.currentx
                }
                return 0
            },
            tableItems() {
                if (this.isMounted) {
                    return this.$refs.table.queriedResults.length
                }
                return 0
            },
            tableData() {
                return this.clients
            }
        },
        mounted() {
            this.isMounted = true
            this.loadData()
        }

    }

</script>
